    import React from 'react';
import TocPage from './generic/TocPage';
import getLegalLinks from './Legal/getLegalLinks';

import m2493245 from'../media/ift/InternetATF/01 PAQUETE 1 ON INTERNET ALÁMBRICO TF 389.pdf';
import m2493970 from'../media/ift/InternetATF/02 PAQUETE 2 ON INTERNET ALÁMBRICO TF 435.pdf';
import m2493969 from'../media/ift/InternetATF/03 PAQUETE 3 ON INTERNET ALÁMBRICO TF 499.pdf';
import m2493971 from'../media/ift/InternetATF/04 PAQUETE 4 ON INTERNET ALÁMBRICO TF 599.pdf';
import m2493972 from'../media/ift/InternetATF/05 PAQUETE 5 ON INTERNET ALÁMBRICO TF 999.pdf';
import m302958 from '../media/ift/InternetATF/FormatoSimplificado_302958.pdf';
import m302960 from '../media/ift/InternetATF/FormatoSimplificado_302960.pdf';
import m314639 from '../media/ift/InternetATF/FormatoSimplificado_314639.pdf';


import m2493974 from'../media/ift/InternetAlTFF/01 PAQUETE 1 ON INTERNET ALÁMBRICO TF 389 FRANJA FRONTERIZA.pdf';
import m2493982 from'../media/ift/InternetAlTFF/02 PAQUETE 2 ON INTERNET ALÁMBRICO TF 435 FRANJA FRONTERIZA.pdf';
import m2493984 from'../media/ift/InternetAlTFF/03 PAQUETE 3 ON INTERNET ALÁMBRICO TF 499 FRANJA FRONTERIZA.pdf';
import m2493986 from'../media/ift/InternetAlTFF/04 PAQUETE 4 ON INTERNET ALÁMBRICO TF 599 FRANJA FRONTERIZA.pdf';
import m2493988 from'../media/ift/InternetAlTFF/05 PAQUETE 5 ON INTERNET ALÁMBRICO TF 999 FRANJA FRONTERIZA.pdf';
import m305592 from '../media/ift/InternetAlTFF/FormatoSimplificado_305592.pdf';
import m305594 from '../media/ift/InternetAlTFF/FormatoSimplificado_305594.pdf';
import m316307 from '../media/ift/InternetAlTFF/FormatoSimplificado_316307.pdf';




const Rates = props =>
{
    return (
        <div id='rates' className='container p-4'>
            <TocPage history={props.history} links={getLegalLinks()}>
                <h4 className='mb-4'>REGISTRO DE TARIFAS ANTE IFT</h4>

                  <table className='table table-striped table-bordered'>
                    <thead className='thead-dark'>

                         <tr className='thead-dark'>
                             <th className='td-title' colspan="2">ON ALÁMBRICO INTERNET + TELEFONÍA FIJA</th>
                        </tr>
                        <tr>
                            <th>NOMBRE</th>
                            <th>TARIFA</th>
                        </tr>
                    </thead>
                    <tbody>
                         <tr>
                            <td>PAQUETE 1 ON INTERNET ALÁMBRICO + TF 389</td>
                            <td><a href={m2493245} target='_blank' rel='noopener noreferrer'>2493245</a></td>
                        </tr>
                        <tr>
                            <td>PAQUETE 2 ON INTERNET ALÁMBRICO + TF 435</td>
                            <td><a href={m2493970} target='_blank' rel='noopener noreferrer'>2493970</a></td>
                        </tr>
                        <tr>
                            <td>PAQUETE 3 ON INTERNET ALÁMBRICO + TF 499</td>
                            <td><a href={m2493969} target='_blank' rel='noopener noreferrer'>2493969</a></td>
                        </tr>
                        <tr>
                            <td>PAQUETE 4 ON INTERNET ALÁMBRICO + TF 599</td>
                            <td><a href={m2493971} target='_blank' rel='noopener noreferrer'>2493971</a></td>
                        </tr>
                        <tr>
                            <td>PAQUETE 5 ON INTERNET ALÁMBRICO + TF 999</td>
                            <td><a href={m2493972} target='_blank' rel='noopener noreferrer'>2493972</a></td>
                        </tr>
                        <tr>
                            <td>Promoción para paquetes superiores Paquete 435</td>
                            <td><a href={m302958} target='_blank' rel='noopener noreferrer'>302958</a></td>
                        </tr>
                        <tr>
                            <td>Promoción para paquetes superiores Paquete 499</td>
                            <td><a href={m302960} target='_blank' rel='noopener noreferrer'>302960</a></td>
                        </tr>
                        <tr>
                            <td>Promoción para paquetes superiores Paquete 599</td>
                            <td><a href={m314639} target='_blank' rel='noopener noreferrer'>314639</a></td>
                        </tr>
                       
                       
                    </tbody>
                </table>


              

                  <table className='table table-striped table-bordered'>
                    <thead className='thead-dark'>

                         <tr className='thead-dark'>
                             <th className='td-title' colspan="2">ON ALÁMBRICO INTERNET + TELEFONÍA FIJA IVA FRONTERIZO</th>
                        </tr>
                        <tr>
                            <th>NOMBRE</th>
                            <th>TARIFA</th>
                        </tr>
                    </thead>
                    <tbody>
                         <tr>
                            <td>Paquete 1 ON Internet Alámbrico + TF 389</td>
                            <td><a href={m2493974} target='_blank' rel='noopener noreferrer'>2493974</a></td>
                        </tr>
                        <tr>
                            <td>Paquete 2 ON Internet Alámbrico + TF 435</td>
                            <td><a href={m2493982} target='_blank' rel='noopener noreferrer'>2493982</a></td>
                        </tr>
                        <tr>
                            <td>Paquete 3 ON Internet Alámbrico + TF 499</td>
                            <td><a href={m2493984} target='_blank' rel='noopener noreferrer'>2493984</a></td>
                        </tr>
                        <tr>
                            <td>Paquete 5 ON Internet Alámbrico + TF 599</td>
                            <td><a href={m2493986} target='_blank' rel='noopener noreferrer'>2493986</a></td>
                        </tr>
                        <tr>
                            <td>Paquete 4 ON Internet Alámbrico + TF 999</td>
                            <td><a href={m2493988} target='_blank' rel='noopener noreferrer'>2493988</a></td>
                        </tr>
                        <tr>
                            <td>Promoción para paquetes superiores Paquete 435</td>
                            <td><a href={m305592} target='_blank' rel='noopener noreferrer'>305592</a></td>
                        </tr>
                        <tr>
                            <td>Promoción para paquetes superiores Paquete 499</td>
                            <td><a href={m305594} target='_blank' rel='noopener noreferrer'>305594</a></td>
                        </tr>
                        <tr>
                            <td>Promoción para paquetes superiores Paquete 599</td>
                            <td><a href={m316307} target='_blank' rel='noopener noreferrer'>316307</a></td>
                        </tr>
                       
                       
                    </tbody>
                </table>


                <p>Las tarifas ante señaladas pueden consultarse en el Registro Público de Concesiones, publicado en la página electrónica del Instituto Federal de Telecomunicaciones</p>



            </TocPage>
        </div>
    );
}

export default Rates;



// WEBPACK FOOTER //
// ./src/components/Rates_an_fija.js